import React from 'react';

import { useIntl } from 'react-intl';

import CommentIcon from '@atlaskit/icon/core/comment';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives/compiled/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/compiled/text';

import { i18n } from './messages';

export const CommentCount = ({
	numberOfComments,
}: {
	numberOfComments: number;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.050">
			{<CommentIcon label={formatMessage(i18n.commentIconLabel)} />}
			<Text size="small" color="color.text.subtlest">
				{numberOfComments}
			</Text>
		</Inline>
	);
};

export const getCommentCount = (numberOfComments?: number | null): React.JSX.Element | null => {
	if (!numberOfComments || numberOfComments === 0) {
		return null;
	}
	return <CommentCount numberOfComments={numberOfComments} />;
};
